// src/Components/RegisterQR.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FiPhoneCall } from "react-icons/fi";
import { BsWhatsapp } from "react-icons/bs";
import API from "../api/config.js"; 
import WLogo from "../assets/TravelXOXO 1.png"

import { BsBag } from "react-icons/bs";

// const getInitialTheme = () => {
//   if (typeof window !== "undefined") {
//     return localStorage.getItem("travelxoxo-theme") || "light";
//   }
//   return "light";
// };

const InputGroup = ({ label, id, type, value, onChange, placeholder, required = true }) => (
  <div className="space-y-2">
    <label
      htmlFor={id}
      className="block text-xs font-semibold uppercase text-gray-500  tracking-wider"
    >
      {label} {required && <span className="text-orange-500">*</span>}
    </label>
    <input
      type={type}
      id={id}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      className="w-full p-4 border border-gray-200  rounded-xl bg-gray-50  text-gray-900  placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 transition duration-150"
    />
  </div>
);

const RegisterQR = () => {
  const { qrId } = useParams();
  const navigate = useNavigate();
  // const [theme, setTheme] = useState(getInitialTheme);
  const [loading, setLoading] = useState(true);
  const [registered, setRegistered] = useState(false);
  const [qrData, setQRData] = useState(null);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [termsToast, setTermsToast] = useState(false);


  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    altPhone: "",
    email: "",
    location: "",
    product: "",
    instructions: "",
  });


  const instructionOptions = [
  "Call me if found",
  "WhatsApp me if found",

];


// --- OTP modal state ---
const [showOtpModal, setShowOtpModal] = useState(false);
const [otpEmail, setOtpEmail] = useState("");
const [otpCode, setOtpCode] = useState("");
const [otpSent, setOtpSent] = useState(false);
const [sending, setSending] = useState(false);
const [verifying, setVerifying] = useState(false);
const [otpError, setOtpError] = useState("");

const openOtpModal = () => {
  setShowOtpModal(true);
  setOtpError("");
  setOtpCode("");
};

const closeOtpModal = () => {
  if (sending || verifying) return;
  setShowOtpModal(false);
  setOtpEmail("");
  setOtpCode("");
  setOtpSent(false);
  setOtpError("");
};




// Get code
const handleGetCode = async () => {
  setOtpError("");
  if (!otpEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(otpEmail)) {
    setOtpError("Please enter a valid email address.");
    return;
  }
  try {
    setSending(true);
    await API.post("/auth/request-otp", { email: otpEmail.trim().toLowerCase(), qrId });
    setOtpSent(true);
  } catch (err) {
    setOtpError(err.response?.data?.message || err.message || "Failed to send code. Try again.");
  } finally {
    setSending(false);
  }
};

const handleVerify = async () => {
  setOtpError("");
  if (!otpCode || otpCode.length !== 5) {
    setOtpError("Enter the 5-digit code sent to your email.");
    return;
  }
  try {
    setVerifying(true);
    await API.post("/auth/verify-otp", { email: otpEmail.trim().toLowerCase(), otp: otpCode, qrId });
    navigate(`/registrations/${qrId}`, { state: { email: otpEmail.trim().toLowerCase() } });
  } catch (err) {
    setOtpError(err.response?.data?.message || err.message || "Invalid or expired code. Please try again.");
  } finally {
    setVerifying(false);
  }
};

  useEffect(() => {
  document.documentElement.classList.remove("dark");
  document.body.className = "bg-gray-50 text-gray-900";
}, []);


useEffect(() => {
  if (!qrId) return;

  (async () => {
    try {
      setLoading(true);
      setError("");

      const res = await API.get(`/registrations/scan/${qrId}`);
      const isRegistered = !!res.data?.registered;

      setRegistered(isRegistered);
      setQRData(res.data?.data || null);

      // 🔁 REDIRECT RULE
      if (!isRegistered && window.location.pathname.startsWith("/register")) {
        navigate(`/${qrId}`, { replace: true });
      }

      if (isRegistered && !window.location.pathname.startsWith("/register")) {
        // allow public found page
        return;
      }

    } catch (err) {
      setError(err?.response?.data?.message || "Failed to load QR");
    } finally {
      setLoading(false);
    }
  })();
}, [qrId, navigate]);


if (loading) return <p className="text-center mt-8">Loading…</p>;
if (error) {
  return (
    <div className="max-w-xl mx-auto p-4">
      <div className="mb-3 rounded-xl bg-red-100 text-red-800 p-3">{error}</div>
      <div className="text-sm text-gray-600">QR ID: {qrId}</div>
    </div>
  );
}


  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  // --- Submit Registration ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post(`/registrations/register/${qrId}`, formData);
      setSuccess(true);
      setRegistered(true);
      setQRData({
        owner_name: formData.name,
        primary_phone: formData.phone,
        alternate_phone: formData.altPhone,
        organization_name: formData.location,
        product_name: formData.product,
        what_to_do_if_found: formData.instructions,
      });
      setTimeout(() => setSuccess(false), 5000);
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        err.response?.data?.error ||
        (Array.isArray(err.response?.data?.errors)
          ? err.response.data.errors.join(", ")
          : null) ||
        err.message ||
        "Error registering QR";
      alert(errorMessage);
    }
  };

  if (loading) return <p className="text-center mt-8">Loading...</p>;

  // --- helpers: phone utilities ---
  const cleanPhone = (n) => String(n || "").replace(/\D/g, "");
  const toE164 = (n) => {
    const s = cleanPhone(n);
    if (!s) return "";
    if (s.length === 10) return `+91${s}`;
    if (s.startsWith("91") && s.length >= 12) return `+${s}`;
    return s.startsWith("+") ? s : `+${s}`;
  };
  const handleCall = (n) => {
    const e164 = toE164(n);
    if (!e164) return;
    window.location.href = `tel:${e164}`;
  };
 
  const handleWhatsApp = (n) => {
  const e164 = toE164(n);
  if (!e164) return;

  const wa = e164.replace("+", "");

  const ownerName = qrData?.owner_name || "there";
  const productName = qrData?.product_name || "your item";
  const message = `Hi ${ownerName}, I have found your ${productName}. I'm trying to reach you to return it.`;

  const url = `https://wa.me/${wa}?text=${encodeURIComponent(message)}`;

  window.open(url, "_blank", "noopener,noreferrer");
};

  return (

    
    <div className="max-w-xl mx-auto p-4 sm:p-8 min-h-screen bg-gray-50  transition-colors duration-300">
      {/* header */}
      <div className="flex justify-between items-center mb-8">
  <img
    src={WLogo}
    alt="Travelxoxo Logo"
    className="h-10 w-auto object-contain transition-all duration-300"
  />

  
<div className="flex flex-col items-center gap-1">
  <button
    className="w-12 h-12 rounded-full bg-orange-600 text-white flex items-center justify-center transition-transform duration-200 hover:scale-105 shadow-lg"
    onClick={() => window.open("https://hourglass.gifts/", "_blank")}
    title="Shop Now"
  >
    <BsBag className="text-white text-xl" />
  </button>

  <span className="text-[10px] font-semibold uppercase tracking-wide text-orange-600">
    Shop Now
  </span>
</div>

</div>

{termsToast && (
  <div className="fixed top-16 left-1/2 -translate-x-1/2 z-50 px-4 py-3 rounded-xl bg-orange-600 text-white text-sm font-semibold shadow-xl">
    Please read and accept the Terms of Use and Privacy Policy
  </div>
)}


      {success && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 p-4 rounded-xl bg-green-500 text-white font-medium z-50 shadow-2xl">
          Registration successful!
        </div>
      )}

      {/* form vs registered state */}
      {!registered ? (
        <form className="space-y-5" onSubmit={handleSubmit}>
          <InputGroup label="Name" id="name" type="text" value={formData.name} onChange={handleChange} placeholder="Enter your full name" />
          <InputGroup label="Phone Number" id="phone" type="tel" value={formData.phone} onChange={handleChange} placeholder="+91 98765 43210" />
          <InputGroup label="Alternate Phone Number" id="altPhone" type="tel" value={formData.altPhone} onChange={handleChange} placeholder="+91 98765 43210" required={false} />
          <InputGroup label="Email" id="email" type="email" value={formData.email} onChange={handleChange} placeholder="Enter your email  ( john@gmail.com, john@icloud.com etc)" />
          <InputGroup label="Office/School/College" id="location" type="text" value={formData.location} onChange={handleChange} placeholder="Enter your organization" />
          <InputGroup label="what would you like to call me?" id="product" type="text" value={formData.product} onChange={handleChange} placeholder="Travelxoxo Backpack" />
          <div className="space-y-2">
  <label className="block text-xs font-semibold uppercase text-gray-500 tracking-wider">
    What to do if found <span className="text-orange-500">*</span>
  </label>

  <div className="flex flex-wrap gap-2">
    {instructionOptions.map((option) => (
      <button
        key={option}
        type="button"
        onClick={() =>
          setFormData((prev) => ({ ...prev, instructions: option }))
        }
        className={`px-4 py-2 rounded-full text-sm font-semibold border transition
          ${
            formData.instructions === option
              ? "bg-orange-600 text-white border-orange-600"
              : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"
          }`}
      >
        {option}
      </button>
    ))}
  </div>

  {/* hidden input for required validation */}
  <input type="hidden" value={formData.instructions} required />
</div>

          <div className="flex items-start gap-3 text-sm text-gray-600">
  <input
    type="checkbox"
    id="terms"
    checked={acceptedTerms}
    onChange={(e) => setAcceptedTerms(e.target.checked)}
    className="mt-1 h-4 w-4 rounded border-gray-300 text-orange-600 focus:ring-orange-500"
    required
  />
  <label htmlFor="terms">
    I agree to the{" "}
    <a
      href="/terms"
      target="_blank"
      rel="noopener noreferrer"
      className="text-orange-600 font-semibold hover:underline"
    >
      Terms of Use
    </a>{" "}
    and{" "}
    <a
      href="/privacypolicy"
      target="_blank"
      rel="noopener noreferrer"
      className="text-orange-600 font-semibold hover:underline"
    >
      Privacy Policy
    </a>
  </label>
</div>

 <div
  onClick={() => {
    if (!acceptedTerms) {
      setTermsToast(true);
      setTimeout(() => setTermsToast(false), 3000);
    }
  }}
  className={!acceptedTerms ? "cursor-not-allowed" : ""}
>
  <button
  type="submit"
  disabled={!acceptedTerms}
  className={`w-full py-4 bg-orange-600 text-white font-extrabold rounded-xl transition duration-200
    ${!acceptedTerms ? "opacity-60 cursor-not-allowed pointer-events-none" : "hover:bg-orange-700"}
  `}
>
  Register QR
</button>

</div>


        </form>
      ) : (
        // --- Registered view ---
        <div className="space-y-6">
          <div className="bg-white  p-6 rounded-2xl shadow-xl text-center">
            
            <div className="flex justify-center">
  <button
    type="button"
    onClick={openOtpModal}
    className="hero-icon flex items-center justify-center w-16 h-16 rounded-full bg-orange-100 text-orange-600 shadow-md hover:bg-orange-200 active:scale-95 transition mb-2"
    aria-label="Verify owner via email OTP"
    title="Verify owner via email OTP"
  >
    <svg
      className="w-8 h-8"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4" />
      <path d="M12 8h.01" />
    </svg>
  </button>
</div>

         
            
            

            <h1 className="text-3xl font-bold text-gray-900  mb-3">Item Found!</h1>
            <p className="text-xs font-semibold uppercase text-gray-500  mb-2">
              Please help return this item to its owner
            </p>
            <div className="inline-block mt-3 px-4 py-1 bg-orange-600 text-white text-sm font-semibold rounded-full shadow-md">
              {qrData.product_name}
            </div>
          </div>

          {/* Owner Info */}
          <div className="bg-white  p-6 rounded-2xl shadow-xl space-y-4">
            <p className="text-xs font-semibold uppercase text-gray-500  mb-2">
              Owner Information
            </p>
            <div className="text-xs font-semibold uppercase text-gray-500 ">Name</div>
            <div className="text-base font-medium text-gray-900 ">{qrData.owner_name}</div>

            <div className="text-xs font-semibold uppercase text-gray-500  mt-4">Organization</div>
            <div className="text-base font-medium text-gray-900 ">{qrData.organization_name}</div>

            <div className="text-xs font-semibold uppercase text-gray-500  mt-4">Instructions</div>
            <div className="p-4 bg-gray-50  rounded-xl">{qrData.what_to_do_if_found}</div>
          </div>

          {/* Contact Owner CTA */}
          <div className="bg-white  p-6 rounded-2xl shadow-xl">
            <p className="text-xs font-semibold uppercase text-gray-500  mb-4">
              Contact Owner
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <button onClick={() => handleCall(qrData?.primary_phone)} className="flex items-center justify-center gap-2 rounded-2xl bg-blue-600 text-white py-3 font-semibold hover:bg-blue-700 transition-all">
                <FiPhoneCall size={20} className="text-white" /> Call Primary
              </button>

              <button onClick={() => handleWhatsApp(qrData?.primary_phone)} className="flex items-center justify-center gap-2 rounded-2xl bg-green-600 text-white py-3 font-semibold hover:bg-green-700 transition-all">
                <BsWhatsapp size={20} className="text-white" /> WhatsApp
              </button>
            </div>

            {qrData?.alternate_phone && (
              <>
                <div className="my-5 text-center">
                  <div className="mt-2 h-px w-full bg-gray-200 " />
                </div>
                <p className="text-xs font-semibold uppercase text-gray-500  mb-4">
                  Alternate Number
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <button onClick={() => handleCall(qrData?.alternate_phone)} className="flex items-center justify-center gap-2 rounded-2xl bg-blue-600 text-white py-3 font-semibold hover:bg-blue-700 transition-all">
                    <FiPhoneCall size={20} className="text-white" /> Call Alternate
                  </button>

                  <button onClick={() => handleWhatsApp(qrData?.alternate_phone)} className="flex items-center justify-center gap-2 rounded-2xl bg-green-600 text-white py-3 font-semibold hover:bg-green-700 transition-all">
                    <BsWhatsapp size={20} className="text-white" /> WhatsApp
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}


{/* modal for OTP verification */}
{showOtpModal && (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center p-4"
    aria-modal="true"
    role="dialog"
  >
    {/* Backdrop */}
    <div
      className="absolute inset-0 bg-black/50"
      onClick={closeOtpModal}
    />

    {/* Dialog */}
    <div className="relative z-10 w-full max-w-md rounded-2xl bg-white  shadow-2xl p-6">
      <div className="flex items-start justify-between">
        <h3 className="text-lg font-bold text-gray-900 ">
          Verify Ownership
        </h3>
        <button
          onClick={closeOtpModal}
          className="ml-3 text-gray-500 hover:text-gray-700 "
          aria-label="Close modal"
        >
          ✕
        </button>
      </div>

      <p className="mt-1 text-sm text-gray-600 ">
        Enter the registration email, get a 5-digit code, then verify to edit details.
      </p>

      {/* Email input + Get Code */}
      <div className="mt-5 space-y-2">
        <label className="block text-xs font-semibold uppercase text-gray-500  tracking-wider">
          Registration Email
        </label>
        <input
          type="email"
          value={otpEmail}
          onChange={(e) => setOtpEmail(e.target.value)}
          placeholder="you@example.com"
          className="w-full p-3 border border-gray-200  rounded-xl bg-gray-50  text-gray-900  placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500"
        />
        <button
          onClick={handleGetCode}
          disabled={sending}
          className="w-full mt-2 py-3 rounded-xl font-semibold text-white bg-orange-600 hover:bg-orange-700 disabled:opacity-60"
        >
          {sending ? "Sending..." : (otpSent ? "Resend Code" : "Get Code")}
        </button>
        {otpSent && (
          <div className="text-xs text-green-600 ">
            Code sent! Check your inbox (valid for 5 minutes).
          </div>
        )}
      </div>

      {/* OTP input + Verify */}
      <div className="mt-5 space-y-2">
        <label className="block text-xs font-semibold uppercase text-gray-500  tracking-wider">
          Enter 5-digit Code
        </label>
        <input
          type="text"
          inputMode="numeric"
          maxLength={5}
          value={otpCode}
          onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, "").slice(0,5))}
          placeholder="12345"
          className="tracking-widest text-center text-lg w-full p-3 border border-gray-200  rounded-xl bg-gray-50  text-gray-900  placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500"
        />
        <button
          onClick={handleVerify}
          disabled={!otpSent || verifying || otpCode.length !== 5}
          className="w-full mt-2 py-3 rounded-xl font-extrabold text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-60"
        >
          {verifying ? "Verifying..." : "Verify & Edit Details"}
        </button>
      </div>

      {/* Error */}
      {!!otpError && (
        <div className="mt-4 text-sm text-red-600 ">
          {otpError}
        </div>
      )}
    </div>
  </div>
)}


    </div>
  );
};

export default RegisterQR;


